var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var _excluded = ["className", "onShare", "buttonText", "type", "theme", "children"];
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
__name(_objectWithoutProperties, "_objectWithoutProperties");
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
__name(_objectWithoutPropertiesLoose, "_objectWithoutPropertiesLoose");
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck, "_classCallCheck");
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
__name(_defineProperties, "_defineProperties");
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
__name(_createClass, "_createClass");
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
__name(_callSuper, "_callSuper");
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
__name(_possibleConstructorReturn, "_possibleConstructorReturn");
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
__name(_assertThisInitialized, "_assertThisInitialized");
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = /* @__PURE__ */ __name(function _isNativeReflectConstruct2() {
    return !!t;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct, "_isNativeReflectConstruct");
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
__name(_getPrototypeOf, "_getPrototypeOf");
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
__name(_inherits, "_inherits");
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
__name(_setPrototypeOf, "_setPrototypeOf");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React, { Component, Children } from "react";
import classnames from "classnames";
import { Button } from "@riseart/common";
import { ShareIcon } from "@riseart/icons";
import { ShareOverlay } from "../overlay/Overlay";
import { shareBtnCls, shareBtnTypeCircleCls, shareBtnThemeLightCls, shareBtnThemeDarkCls } from "./Button.less";
var TYPE_TO_CLASSNAME = {
  circle: shareBtnTypeCircleCls
};
var THEME_TO_CLASSNAME = {
  light: shareBtnThemeLightCls,
  dark: shareBtnThemeDarkCls
};
var ShareButton = /* @__PURE__ */ function(_Component) {
  function ShareButton2(props) {
    var _this;
    _classCallCheck(this, ShareButton2);
    _this = _callSuper(this, ShareButton2, [props]);
    _this.state = {
      opened: false
    };
    _this.bindMethods();
    return _this;
  }
  __name(ShareButton2, "ShareButton");
  _inherits(ShareButton2, _Component);
  return _createClass(ShareButton2, [{
    key: "handleClick",
    value: /* @__PURE__ */ __name(function handleClick() {
      var opened = this.state.opened;
      this.setState({
        opened: !opened
      });
    }, "handleClick")
    /**
     * bindMethods
     */
  }, {
    key: "bindMethods",
    value: /* @__PURE__ */ __name(function bindMethods() {
      this.handleClick = this.handleClick.bind(this);
    }, "bindMethods")
    /**
     * render
     */
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function render() {
      var _this2 = this;
      var _this$props = this.props, className = _this$props.className, onShare = _this$props.onShare, buttonText = _this$props.buttonText, type = _this$props.type, theme = _this$props.theme, children = _this$props.children, restProps = _objectWithoutProperties(_this$props, _excluded);
      return /* @__PURE__ */ React.createElement(React.Fragment, null, children ? Children.map(children, function(child) {
        return /* @__PURE__ */ React.cloneElement(child, {
          onClick: _this2.handleClick
        });
      }) : /* @__PURE__ */ React.createElement(Button, {
        icon: /* @__PURE__ */ React.createElement(ShareIcon, null),
        type: "link",
        linkType: "light",
        className: classnames(shareBtnCls, type && TYPE_TO_CLASSNAME[type], theme && THEME_TO_CLASSNAME[theme], className),
        onClick: this.handleClick
      }, buttonText), this.state.opened && /* @__PURE__ */ React.createElement(ShareOverlay, _extends({}, restProps, {
        onShare,
        onClose: this.handleClick,
        isVisible: this.state.opened
      })));
    }, "render")
  }]);
}(Component);
_defineProperty(ShareButton, "defaultProps", {
  className: null,
  onShare: null,
  buttonText: null,
  children: null,
  type: "transparent",
  theme: "light"
});
export {
  ShareButton
};
